import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from './Footer';

import style from '../style/landing_ui.module.css';
import logo from '../assets/LaunchScreen@2x.png';
import phone from '../assets/Group@3x@3x.png';
import google from '../assets/GetItOnGooglePlay_Badge_Web_color_English.png';
import apple from '../assets/black.svg';

const TruckOwners = () => {
	return (
		<div className={style.background}>
			<Container style={{ flex: 1 }}>
				<br/>
				<Row className={style.pushFooter}>
					<Col id="headerStyle">
						<p className={style.body}>
						<img src={logo} alt="Grub Truck Logo" className={style.logo} />
							<br/>
							<br/>
							GrubTrucks is a free app that helps customers find your food truck!<br/><br/>Not a food truck owner? Check out:<br/>
							<a href="https://grubtrucks.info" className="btn">Grub Trucks</a><br/><br/>
							<div className={style.appButtons}>
								<a href="https://apps.apple.com/us/app/grub-trucks/id1116325681?itsct=apps_box_badge&amp;itscg=30200" target="_blank" rel="noopener noreferrer">
									<img src={apple} className={style.appleButton} alt="Download on the App Store" />
								</a>
								<a href="https://play.google.com/store/apps/details?id=com.webdmg.grub.truck" target="_blank" rel="noopener noreferrer">
									<img src={google} className={style.googleButton} alt="Get it on Google Play" />
								</a>
							</div>
							Features:<br/>
							<ul>
								<li>Easily notify customers of your current location</li>
								<li>Schedule upcoming locations</li>
								<li>Add social media and order ahead website</li>
							</ul>
							<br/>
						</p>
					</Col>
					<Col className={style.hide}>
						<div className={style.phoneCenter}>
							<img src={phone} alt="Grub Truck Logo" className={style.phone} />
						</div>
					</Col>
				</Row>
			</Container>
			<Footer />
		</div>
	);
};

export default TruckOwners;
